import { connect } from 'react-redux';
import PublicSiteForPosChangesListing from "./Listing";
import { bindActionCreators } from 'redux';
import {
    getSiteFilters,
    getLocationChange,
    getPublicSiteListingForChanges,
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
    posReplaceReturn: state.siteListingReducer.posReplaceReturn,
    siteFilters: state.siteListingReducer.siteFiltersData,
    locationChange: state.siteListingReducer.locationChange,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getPublicSiteListingForChanges,
            getSiteFilters,
            getLocationChange,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PublicSiteForPosChangesListing);
